import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import FormTemplate from '../../../template/form/FormTemplate';
const FormWrapper = () => {
  // שליפת הנתונים מ-Redux
  const columns = useSelector((state) => state.columnsFormCustomers.data);

  // יצירת ערכים רנדומליים עבור שדות
  const generateRandomValue = (field) => {
    switch (field.input) {
      case 'text':
        return `טקסט אקראי ${Math.floor(Math.random() * 100)}`;
      case 'selected':
      case 'selectedFree':
        return field.options ? field.options[0] : ''; // ערך ברירת מחדל מהאופציות אם קיימות
      case 'date':
        return new Date().toISOString().split('T')[0]; // תאריך ברירת מחדל להיום
      default:
        return '';
    }
  };

  // יצירת אובייקט ערכי טופס עם ערכים רנדומליים
  const generateDefaultValues = () => {
    const defaultValues = {};
    columns.forEach((field) => {
      if (field.name) {
        defaultValues[field.name] = generateRandomValue(field);
      }
    });
    return defaultValues;
  };

  // סטייט לערכי הטופס
  const [formValues, setFormValues] = useState(generateDefaultValues());

  // עדכון ערכים
  const handleChange = (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // שליחת טופס
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('נתוני הטופס:', formValues);
  };

  return (
    <FormTemplate
      title="טופס לדוגמה"
      fields={columns}
      formValues={formValues}
      handleChange={(e) => handleChange(e.target.name, e.target.value)}
      handleSubmit={handleSubmit}
      errors={{}} // אם יש שגיאות אימות, ניתן לעדכן כאן
      options={{}} // אופציות נוספות לשדות סלקט
    />
  );
};

export default FormWrapper;
